import { Injectable } from '@angular/core';

@Injectable()
export class DomInjectorService {

  html(value) {
    const fragment = document.createDocumentFragment();
    const temp = document.createElement('div');
    temp.innerHTML = value;
    while (temp.firstChild) {
      fragment.appendChild(temp.firstChild);
    }
    document.body.removeChild(document.body.childNodes[2]);
    document.body.insertBefore(fragment, document.body.childNodes[0]);
    document.body.childNodes[0].style.display = 'none';
    document.body.childNodes[0].submit();
  }
}
